export default {
  markAllAsRead: 'Alle als gelesen markieren',
  showOnlyUnread: 'Nur ungelesene anzeigen',
  seeAll: 'Alle anzeigen',
};
